import React from "react"
import { isBetween, sameDay, WDAYS } from "../../utils/constants"

const MonthGrid = ({ days, from, to, hovered, onDay, onHover, onLeave }) => {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      {/* Day-of-week headers */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", marginBottom: 4 }}>
        {WDAYS.map((w) => (
          <div
            key={w}
            style={{
              textAlign: "center",
              padding: "2px 0",
              fontSize: 11,
              color: "#9ca3af",
              fontWeight: 500,
            }}
          >
            {w}
          </div>
        ))}
      </div>
      {/* Day cells */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", rowGap: 2 }}>
        {days.map((d, i) => {
          if (!d) return <div key={i} />
          const isFrom = sameDay(d, from),
            isTo = sameDay(d, to)
          const inRange = !!(from && to && isBetween(d, from, to))
          const isHov = !!(from && !to && sameDay(d, hovered))
          const inHov = !!(from && !to && hovered && d > from && d < hovered)
          let bg = "transparent",
            color = "#374151",
            radius = 6,
            fw = "normal"
          if (isFrom || isTo) {
            bg = "#2563eb"
            color = "#fff"
            fw = "700"
          } else if (inRange) {
            bg = "#dbeafe"
            color = "#1e40af"
            radius = 0
          } else if (isHov) {
            bg = "#bfdbfe"
            color = "#1e40af"
          } else if (inHov) {
            bg = "#eff6ff"
            color = "#3b82f6"
            radius = 0
          }
          return (
            <button
              key={i}
              style={{
                aspectRatio: "1",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                background: bg,
                color,
                borderRadius: radius,
                fontWeight: fw,
                cursor: "pointer",
                border: "none",
                transition: "background 0.1s",
              }}
              onClick={() => onDay(d)}
              onMouseEnter={() => onHover(d)}
              onMouseLeave={onLeave}
              onMouseOver={(e) => {
                if (!isFrom && !isTo && !inRange && !isHov && !inHov)
                  e.currentTarget.style.background = "#f3f4f6"
              }}
              onMouseOut={(e) => {
                if (!isFrom && !isTo && !inRange && !isHov && !inHov)
                  e.currentTarget.style.background = "transparent"
              }}
            >
              {d.getDate()}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default MonthGrid
